var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/functional/remove/grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,11.25 L16.25,11.25 C16.6642136,11.25 17,11.5857864 17,12 C17,12.4142136 16.6642136,12.75 16.25,12.75 L12.75,12.75 L12.75,16.25 C12.75,16.6642136 12.4142136,17 12,17 C11.5857864,17 11.25,16.6642136 11.25,16.25 L11.25,12.75 L7.75,12.75 C7.33578644,12.75 7,12.4142136 7,12 C7,11.5857864 7.33578644,11.25 7.75,11.25 L11.25,11.25 L11.25,7.75 C11.25,7.33578644 11.5857864,7 12,7 C12.4142136,7 12.75,7.33578644 12.75,7.75 L12.75,11.25 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/functional/remove/grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(-5.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#C3CCD7",
    x: 7.5,
    y: 7.5,
    width: 19,
    height: 19,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/functional/plus",
    transform: "translate(17.000000, 17.000000) rotate(45.000000) translate(-17.000000, -17.000000) translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/functional/add"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "border",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M16.25,11.75 L12.25,11.75 L12.25,7.75 C12.25,7.61192881 12.1380712,7.5 12,7.5 C11.8619288,7.5 11.75,7.61192881 11.75,7.75 L11.75,11.75 L7.75,11.75 C7.61192881,11.75 7.5,11.8619288 7.5,12 C7.5,12.1380712 7.61192881,12.25 7.75,12.25 L11.75,12.25 L11.75,16.25 C11.75,16.3880712 11.8619288,16.5 12,16.5 C12.1380712,16.5 12.25,16.3880712 12.25,16.25 L12.25,12.25 L16.25,12.25 C16.3880712,12.25 16.5,12.1380712 16.5,12 C16.5,11.8619288 16.3880712,11.75 16.25,11.75 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/grey",
    mask: "url(#mask-2)",
    fill: "#99A9BB"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.cdddc277e021d8b66af77e5958f62f44.svg";
export { ForwardRef as ReactComponent };